module.exports = __webpack_public_path__ + "static/img/product02.23c7212.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product02.png
// module id = Aa4Z
// module chunks = 1